import { produce } from "immer";
import * as Actions from "pages/Settings/ActiveDevices/store/activeDevicesActions";

import deepmerge from "deepmerge";
import combineMerge from "config/combineMerge";

const initialState = { byId: {}, allIds: [], message: null };
const activeDevicesReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.FETCH_ACTIVE_DEVICES_SUCCESS: {
      const payload = action.payload;
      const activeDevices = payload.activeDevices;
      const activeDeviceIds = payload.activeDevices.map(device => device.id);

      const byId = activeDevices.reduce((obj, device) => {
        obj[device.id] = device;
        return obj;
      }, {});

      draft.byId = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });
      draft.allIds = activeDeviceIds;

      break;
    }
    case Actions.FETCH_DELETE_ACTIVE_DEVICES: {
      const payload = action.payload;
      const message = payload.message;
      draft.message = message;

      break;
    }
    default:
      return draft;
  }
}, initialState);

export default activeDevicesReducer;
